/* Veem: homepage-sectie "Alle producten" toont 2 rijen (8 producten) met
   paginaknoppen eronder; wisselen is client-side (alles is al geladen).
   Alleen de desktop-grid; de mobiele carrousel blijft ongemoeid. */
(function () {
  var SIZE = 8; // 2 rijen x 4 kolommen

  function init() {
    var sec = document.querySelector('[id*="loods_grid"]');
    if (!sec || sec.dataset.veemPager) return;
    var list = sec.querySelector(".resource-list");
    if (!list) return;
    var items = [].filter.call(list.children, function (el) {
      return el.classList && el.classList.contains("resource-list__item");
    });
    if (items.length <= SIZE) return;
    sec.dataset.veemPager = "1";

    var pages = Math.ceil(items.length / SIZE);
    var nav = document.createElement("div");
    nav.className = "veem-pager";

    function show(p) {
      items.forEach(function (el, i) {
        el.style.display = (i >= p * SIZE && i < (p + 1) * SIZE) ? "" : "none";
      });
      [].forEach.call(nav.children, function (b, i) {
        b.classList.toggle("is-active", i === p);
      });
    }

    for (var i = 0; i < pages; i++) {
      (function (i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "veem-pager__btn";
        b.textContent = i + 1;
        b.setAttribute("aria-label", "Pagina " + (i + 1));
        b.addEventListener("click", function () { show(i); });
        nav.appendChild(b);
      })(i);
    }
    var more = document.createElement("a");
    more.href = "/collections/all";
    more.className = "veem-pager__btn veem-pager__more";
    more.textContent = "\u2026";
    more.setAttribute("aria-label", "Alle producten");
    nav.appendChild(more);
    list.parentNode.insertBefore(nav, list.nextSibling);
    function syncVisibility() {
      nav.style.display = getComputedStyle(list).display === "none" ? "none" : "";
    }
    window.addEventListener("resize", syncVisibility);
    syncVisibility();
    show(0);
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
